import React, { useEffect } from 'react';
import DropDown from './UI/DropDown';
import LangSelect from './UI/LangSelect';
import CopyInputField from './UI/CopyInputField';
import { useGetVendorId } from '../../hooks/global/User';
import { useGetAvailableLanguages } from '../../hooks/global/Languages';
import { useTranslation } from 'react-i18next';
import QRCode from './QRCode';

const QrForm = ({ profiles, groups }) => {
    const availableLanguages = useGetAvailableLanguages();
    const { t } = useTranslation();

    const [link, setLink] = React.useState('');
    const [lng, setLng] = React.useState(availableLanguages[0] || 'en'); // Default to 'en' if empty
    const [selected, setSelected] = React.useState(null);
    const vendorId = useGetVendorId();

    useEffect(() => {
        // Generate initial link if profiles or groups are available
        if (selected || profiles?.length || groups?.length) {
            getLink(selected, lng);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected, lng, vendorId]);

    const handleSelect = (item) => {
        setSelected(item);
        getLink(item, lng);
    };

    const handleLangSelect = (language) => {
        setLng(language);
        getLink(selected, language);
    };

    const getLink = (item, language) => {
        const currentLng = language || lng;
        const currentItem = item || selected;

        if (!currentItem || !vendorId) {
            setLink('');
            return;
        }

        if (currentItem.groupName)
            setLink(`${process.env.REACT_APP_BASE_URL}/vendors/${vendorId}/review-from-code/?code=${currentItem.source_id}&lng=${currentLng}`);
        else
            setLink(`${process.env.REACT_APP_BASE_URL}/profiles/${currentItem.id}/review/?lng=${currentLng}`);
    };

    return (
        <>
            <h2 className="header-class">{t('admin.inv.qrMSub')}</h2> {/* Ensure to add 'anonymousLinkForm.title' in your translation files */}

            <div className="description-and-controls">
                <p>{t('admin.inv.reFi')}
                    <div className="dropdown-and-lang">
                        <DropDown profiles={profiles} groups={groups} onSelect={handleSelect} />
                        <LangSelect value={lng} onSelect={handleLangSelect} />
                    </div>
                </p>
            </div>

            <div className="link-description">
                <p className="link-info">
                    <CopyInputField value={link} />
                    <small style={{color:"#333"}}> {t('admin.inv.linkPageSub')}</small>
                </p>
            </div>
            <QRCode link={link} />
        </>
    );
};

export default QrForm;
